export const messages = {
  en: {
    feeSummary: {
      title: 'Fee Summary',
      day: 'Day',
      month: 'Month',
      year: 'Year',
      time: 'Time',
      feeItemId: 'Fee Item ID',
      feeItemName: 'Fee Item Name',
      receivableAmount: 'Receivable Amount',
      receivedAmount: 'Received Amount',
      yuan: 'yuan',
      fetchError: 'Failed to fetch fee summary data'
    }
  },
  zh: {
    feeSummary: {
      title: '缴费汇总表',
      day: '日',
      month: '月',
      year: '年',
      time: '时间',
      feeItemId: '费用项ID',
      feeItemName: '费用项名称',
      receivableAmount: '应收金额',
      receivedAmount: '实收金额',
      yuan: '元',
      fetchError: '获取缴费汇总数据失败'
    }
  }
}